import {
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    centerTitle: {
      textAlign: "center",
      padding: theme.spacing(1),
    },
    downTrend: {
      color: theme.palette.statusRed.main,
    },
    fullHeight: {},
    upTrend: {
      color: theme.palette.statusGreen.main,
    },
    cellChanged: {
      fontWeight: "bolder",
      backgroundColor: theme.palette.highlightRow.main,
    },
    cell: {},
    cards: {
      height: "100%",
    },
  })
);

export interface kpi_line {
  name: string;
  currentValue: number;
  predictedValue: number;
}

export default function CardKPI(props: { kpis: kpi_line[] }) {
  const classes = useStyles();
  const kpis = props.kpis;

  return (
    <Card className={classes.cards}>
      <CardContent className={classes.fullHeight}>
        <Typography variant="h4" className={classes.centerTitle}>
          KPI
        </Typography>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Current</TableCell>
                <TableCell>Predicted</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {kpis.map((kpi: kpi_line, idx: number) => {
                let icon = <></>;
                if (kpi.currentValue > kpi.predictedValue)
                  icon = (
                    <ArrowDownward
                      className={classes.downTrend}
                      fontSize="small"
                    />
                  );
                if (kpi.currentValue < kpi.predictedValue)
                  icon = (
                    <ArrowUpward className={classes.upTrend} fontSize="small" />
                  );
                return (
                  <TableRow key={idx + 1}>
                    <TableCell>{kpi.name}</TableCell>
                    <TableCell>
                      {Math.round(100 * kpi.currentValue) / 100}
                    </TableCell>
                    <TableCell>
                      {Math.round(100 * kpi.predictedValue) / 100}
                    </TableCell>
                    <TableCell>{icon}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}
